import { createAsyncThunk } from '@reduxjs/toolkit';
import { _patientUrls } from '@custom/Utils/constants/apiUrls';

interface ActivateUserArgs {
    userId: string;
}

interface ActivateUserResponse {
    status: string;
    result: any;
    msg?: string;
}

const activatePatientApi = createAsyncThunk<ActivateUserResponse, ActivateUserArgs>('activatePatientApi', async ({ userId }) => {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    try {
        let url = `${_patientUrls.activatePatient}/${userId}`;
        let response = await fetch(url, {
            method: 'PUT',
            headers: {
                Authorization: 'Bearer ' + token,
            },
            body: JSON.stringify({}),
        })
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return await response.json()
    } catch (error) {
        return error;
    }
});

export default activatePatientApi;
